<template>
  <div class="agreement-container">
    <h1 class="agreement-title">Cookie Statement</h1>
    <p>
      This website (isINSPAY.com) is committed to providing users with a safe,
      convenient, and high-quality service experience. During this process, we
      will use Cookie technology. A Cookie is a small text file that is placed
      on your device (such as a computer, smartphone, or tablet) when you visit
      our website.
    </p>
    <h2>I. Types of Cookies</h2>
    <ul>
      <li>
        <strong>Strictly Necessary Cookies</strong>: These cookies are essential
        for the normal operation of the core functions of this website. For
        example, they can be used to implement a secure login mechanism, ensure
        the security of your information during transactions, and maintain the
        overall stability and availability of the website. Without these
        cookies, you may not be able to access key areas of the websitenormally
        or complete basic payment operations. you may not be able to access key
        areas of the website normally or complete basic payment operations.
      </li>
      <li>
        <strong>Performance and Analytics Cookies</strong>: We use this type of
        cookies to collect information about how you use our website, including
        the pages you browse, the time you spend on each page, the links you
        click, and other ways you interact with the website. By analyzing this
        data, we can evaluate the performance of the website, identify potential
        problems or bottlenecks, and then optimize and improve it accordingly,
        so as to provide you with a more smooth and efficient browsing and using
        experience.
      </li>
      <li>
        <strong>Function Cookies</strong>: The main purpose of function cookies
        is to remember your preference settings on this website. For example,
        your chosen language display preferences, interface layout settings, and
        specific service customization options will all be recorded by these
        cookies. In this way, when you visit inINSPAY.com again, the website can
        provide you with a personalized service presentation based on your
        previous settings, saving you the time and effort of reconfiguring.
      </li>
      <li>
        <strong>Third-Party Cookies (Advertising and Partners)</strong>: In some
        cases, we may cooperate with third-party partners, and they may set
        cookies on our website. These third-party cookies are mainly used for
        advertising placement and other cooperation purposes. For example,
        advertisers may use these cookies to display more relevant advertising
        content to you based on your browsing history and interest preferences.
        However, we will strictly control the access rights of third parties to
        your data and ensure that their use complies with relevant laws,
        regulations, and privacy policies.
      </li>
    </ul>
    <h2>II. Purposes of Cookies</h2>
    <ul>
      <li>
        <strong>Ensuring the Continuity and Security of Services</strong>:
        Strictly necessary cookies can monitor your login status and transaction
        process in real time, prevent unauthorized access and malicious attacks,
        and ensure that your personal information and funds are properly
        protected throughout the service process.
      </li>
      <li>
        <strong>Optimizing User Experience and Website Performance</strong>: The
        data collected by performance and analytics cookies helps us gain a deep
        understanding of user behavior patterns, so that we can optimize the
        website's architecture, page design, and function layout in a targeted
        manner, reduce loading times, and increase response speeds, creating a
        more comfortable and convenient using environment for you.
      </li>
      <li>
        <strong>Provosing Personalized Services</strong>: Function cookies
        enable us to customize the display content and service options of the
        website according to your personalized preferences, meet your unique
        needs and expectations, and enhance your overall satisfaction with
        inINSPAY.com.
      </li>
      <li>
        <strong>Supporting Advertising and Partner Cooperation</strong>:
        Third-party cookies provide a data basis for our cooperation with
        partners, allowing us to present advertising information that matches
        your interests to you within the scope of legality and compliance, while
        also providing valuable market insights and promotion channels for our
        partners.
      </li>
    </ul>
    <h2>III. Management of Cookies</h2>
    <p>
      You have certain control over the use of cookies. You can manage the
      acceptance of cookies through your browser settings. Most browsers allow
      you to choose to accept all cookies, reject all cookies, or only accept
      specific types of cookies. You can also set to receive a prompt each time
      a cookie is received, so that you can make a decision according to the
      specific situation.
    </p>
    <p>
      If you wish to delete the cookies already stored on your device, you can
      look for options such as "Clear Browsing Data" or "Delete Cookies" in the
      browser's settings menu and follow the prompts to operate. Please note
      that deleting cookies may cause you to lose some personalized settings on
      this website or other related websites, such as having to re-login or
      re-set preference options.
    </p>
    <p>
      If you want to opt out of the use of third-party advertising cookies, you
      can visit the opt-out links provided by the relevant third-party
      advertising platforms (for example, [specific third-party advertising
      platform opt-out link 1], [specific third-party advertising platform
      opt-out link 2], etc.), and follow their instructions to complete the
      opt-out operation. After opting out, you may still see advertisements, but
      these advertisements will no longer be precisely targeted based on your
      personal browsing history and interest.
    </p>
    <h2>IV. Updates to the Cookies Statement</h2>
    <p>
      We will revise and improve this Cookie Statement in a time manner
      according to the development of our business, technological changes, and
      updates to laws and regulations. We recommend that you regularly check
      this statement to understand our latest policies and practices regarding
      the use of cookies. When we make significant changes to the Cookie
      Statement, we will post a notice in a prominent position on the website,
      informing you of the relevant changes and their effective dates, so that
      you can understand and make corresponding decisions in a time manner.
    </p>
    <p>
      By continuing to use inINSPAY.com, you hereby agree that we will use
      cookies in the manner described in this Cookie Statement. If you have any
      questions, comments, or suggestions regarding our Cookie use policy,
      please feel free to contact us. Our customer service team will be happy to
      serve you and answer your queries.
    </p>
  </div>
</template>

<style scoped>
.agreement-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
}

.agreement-title {
  color: #333;
  /* font-size: 32px; */
  font-weight: 600;
  text-align: center;
  margin-bottom: 40px;
  padding-bottom: 20px;
  border-bottom: 2px solid #eee;
}

/* h2 {
  color: #2c3e50;
  font-size: 24px;
  margin-top: 30px;
  margin-bottom: 20px;
} */

ol {
  padding-left: 20px;
  line-height: 1.6;
}

li {
  margin-bottom: 12px;
  color: #666;
}

p {
  color: #666;
  line-height: 1.6;
}
</style>
<script>
export default {
  name: "AccountDeletionStatement",
  created() {
    // 在组件创建时立即滚动到顶部
    window.scrollTo(0, 0);
  },
  mounted() {
    // 组件挂载后再次确保滚动到顶部
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
  },
};
</script>
